export default __webpack_public_path__ + "static/media/side-menu-icon.b22ca629.svg";